"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/check-return-reason.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fcheck-return-reason.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkReturnReasonToJSON = exports.checkReturnReasonFromJSON = exports.CheckReturnReason = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.proto';
var CheckReturnReason;
(function (CheckReturnReason) {
    CheckReturnReason["INVALID_RETURN_REASON"] = "INVALID_RETURN_REASON";
    /**
     * STOP_PAYMENT - Check blocked by account owner
     */
    CheckReturnReason["STOP_PAYMENT"] = "STOP_PAYMENT";
    CheckReturnReason["ALTER_OR_FICTITIOUS"] = "ALTER_OR_FICTITIOUS";
    CheckReturnReason["BRANCH_OR_ACCOUNT_SOLD"] = "BRANCH_OR_ACCOUNT_SOLD";
    CheckReturnReason["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    CheckReturnReason["CANNOT_DETERMINE_AMOUNT"] = "CANNOT_DETERMINE_AMOUNT";
    CheckReturnReason["DUPLICATE_OR_ITEM_PAID"] = "DUPLICATE_OR_ITEM_PAID";
    CheckReturnReason["DEATH_RECLAMATION"] = "DEATH_RECLAMATION";
    CheckReturnReason["ENDORSEMENT_FORGED"] = "ENDORSEMENT_FORGED";
    CheckReturnReason["ENDORSEMENT_IRREGULAR"] = "ENDORSEMENT_IRREGULAR";
    CheckReturnReason["ENDORSEMENT_MISSING"] = "ENDORSEMENT_MISSING";
    CheckReturnReason["FROZEN_OR_BLOCKED"] = "FROZEN_OR_BLOCKED";
    CheckReturnReason["FORGERY"] = "FORGERY";
    CheckReturnReason["ITEM_EXCEEDS_STATED_MAX_VALUE"] = "ITEM_EXCEEDS_STATED_MAX_VALUE";
    CheckReturnReason["NON_CASH_ITEM"] = "NON_CASH_ITEM";
    CheckReturnReason["NOT_AUTHORIZED"] = "NOT_AUTHORIZED";
    CheckReturnReason["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    CheckReturnReason["OTHER_RETURN_REASON"] = "OTHER_RETURN_REASON";
    CheckReturnReason["POST_DATED"] = "POST_DATED";
    CheckReturnReason["ARP_OR_POSPAY_VIOLATION"] = "ARP_OR_POSPAY_VIOLATION";
    CheckReturnReason["REFER_TO_MAKER"] = "REFER_TO_MAKER";
    CheckReturnReason["REFER_TO_IMAGE"] = "REFER_TO_IMAGE";
    CheckReturnReason["STALE_DATED"] = "STALE_DATED";
    CheckReturnReason["SIGNATURE_FORGED"] = "SIGNATURE_FORGED";
    CheckReturnReason["SIGNATURE_IRREGULAR"] = "SIGNATURE_IRREGULAR";
    CheckReturnReason["SIGNATURE_MISSING"] = "SIGNATURE_MISSING";
    CheckReturnReason["SIGNATURE_UNAUTHORIZED"] = "SIGNATURE_UNAUTHORIZED";
    CheckReturnReason["UNCOLLECTED_FUNDS"] = "UNCOLLECTED_FUNDS";
    CheckReturnReason["UNABLE_TO_LOCATE"] = "UNABLE_TO_LOCATE";
    CheckReturnReason["UNABLE_TO_PROCESS"] = "UNABLE_TO_PROCESS";
    CheckReturnReason["WARRANTY_BREACH"] = "WARRANTY_BREACH";
    CheckReturnReason["REMOTE_CAPTURE_INDEMNITY"] = "REMOTE_CAPTURE_INDEMNITY";
    CheckReturnReason["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CheckReturnReason || (exports.CheckReturnReason = CheckReturnReason = {}));
function checkReturnReasonFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_RETURN_REASON':
            return CheckReturnReason.INVALID_RETURN_REASON;
        case 1:
        case 'STOP_PAYMENT':
            return CheckReturnReason.STOP_PAYMENT;
        case 2:
        case 'ALTER_OR_FICTITIOUS':
            return CheckReturnReason.ALTER_OR_FICTITIOUS;
        case 3:
        case 'BRANCH_OR_ACCOUNT_SOLD':
            return CheckReturnReason.BRANCH_OR_ACCOUNT_SOLD;
        case 4:
        case 'ACCOUNT_CLOSED':
            return CheckReturnReason.ACCOUNT_CLOSED;
        case 5:
        case 'CANNOT_DETERMINE_AMOUNT':
            return CheckReturnReason.CANNOT_DETERMINE_AMOUNT;
        case 6:
        case 'DUPLICATE_OR_ITEM_PAID':
            return CheckReturnReason.DUPLICATE_OR_ITEM_PAID;
        case 7:
        case 'DEATH_RECLAMATION':
            return CheckReturnReason.DEATH_RECLAMATION;
        case 8:
        case 'ENDORSEMENT_FORGED':
            return CheckReturnReason.ENDORSEMENT_FORGED;
        case 9:
        case 'ENDORSEMENT_IRREGULAR':
            return CheckReturnReason.ENDORSEMENT_IRREGULAR;
        case 10:
        case 'ENDORSEMENT_MISSING':
            return CheckReturnReason.ENDORSEMENT_MISSING;
        case 11:
        case 'FROZEN_OR_BLOCKED':
            return CheckReturnReason.FROZEN_OR_BLOCKED;
        case 12:
        case 'FORGERY':
            return CheckReturnReason.FORGERY;
        case 13:
        case 'ITEM_EXCEEDS_STATED_MAX_VALUE':
            return CheckReturnReason.ITEM_EXCEEDS_STATED_MAX_VALUE;
        case 14:
        case 'NON_CASH_ITEM':
            return CheckReturnReason.NON_CASH_ITEM;
        case 15:
        case 'NOT_AUTHORIZED':
            return CheckReturnReason.NOT_AUTHORIZED;
        case 16:
        case 'INSUFFICIENT_FUNDS':
            return CheckReturnReason.INSUFFICIENT_FUNDS;
        case 17:
        case 'OTHER_RETURN_REASON':
            return CheckReturnReason.OTHER_RETURN_REASON;
        case 18:
        case 'POST_DATED':
            return CheckReturnReason.POST_DATED;
        case 19:
        case 'ARP_OR_POSPAY_VIOLATION':
            return CheckReturnReason.ARP_OR_POSPAY_VIOLATION;
        case 20:
        case 'REFER_TO_MAKER':
            return CheckReturnReason.REFER_TO_MAKER;
        case 21:
        case 'REFER_TO_IMAGE':
            return CheckReturnReason.REFER_TO_IMAGE;
        case 22:
        case 'STALE_DATED':
            return CheckReturnReason.STALE_DATED;
        case 23:
        case 'SIGNATURE_FORGED':
            return CheckReturnReason.SIGNATURE_FORGED;
        case 24:
        case 'SIGNATURE_IRREGULAR':
            return CheckReturnReason.SIGNATURE_IRREGULAR;
        case 25:
        case 'SIGNATURE_MISSING':
            return CheckReturnReason.SIGNATURE_MISSING;
        case 26:
        case 'SIGNATURE_UNAUTHORIZED':
            return CheckReturnReason.SIGNATURE_UNAUTHORIZED;
        case 27:
        case 'UNCOLLECTED_FUNDS':
            return CheckReturnReason.UNCOLLECTED_FUNDS;
        case 28:
        case 'UNABLE_TO_LOCATE':
            return CheckReturnReason.UNABLE_TO_LOCATE;
        case 29:
        case 'UNABLE_TO_PROCESS':
            return CheckReturnReason.UNABLE_TO_PROCESS;
        case 30:
        case 'WARRANTY_BREACH':
            return CheckReturnReason.WARRANTY_BREACH;
        case 31:
        case 'REMOTE_CAPTURE_INDEMNITY':
            return CheckReturnReason.REMOTE_CAPTURE_INDEMNITY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CheckReturnReason.UNRECOGNIZED;
    }
}
exports.checkReturnReasonFromJSON = checkReturnReasonFromJSON;
function checkReturnReasonToJSON(object) {
    switch (object) {
        case CheckReturnReason.INVALID_RETURN_REASON:
            return 'INVALID_RETURN_REASON';
        case CheckReturnReason.STOP_PAYMENT:
            return 'STOP_PAYMENT';
        case CheckReturnReason.ALTER_OR_FICTITIOUS:
            return 'ALTER_OR_FICTITIOUS';
        case CheckReturnReason.BRANCH_OR_ACCOUNT_SOLD:
            return 'BRANCH_OR_ACCOUNT_SOLD';
        case CheckReturnReason.ACCOUNT_CLOSED:
            return 'ACCOUNT_CLOSED';
        case CheckReturnReason.CANNOT_DETERMINE_AMOUNT:
            return 'CANNOT_DETERMINE_AMOUNT';
        case CheckReturnReason.DUPLICATE_OR_ITEM_PAID:
            return 'DUPLICATE_OR_ITEM_PAID';
        case CheckReturnReason.DEATH_RECLAMATION:
            return 'DEATH_RECLAMATION';
        case CheckReturnReason.ENDORSEMENT_FORGED:
            return 'ENDORSEMENT_FORGED';
        case CheckReturnReason.ENDORSEMENT_IRREGULAR:
            return 'ENDORSEMENT_IRREGULAR';
        case CheckReturnReason.ENDORSEMENT_MISSING:
            return 'ENDORSEMENT_MISSING';
        case CheckReturnReason.FROZEN_OR_BLOCKED:
            return 'FROZEN_OR_BLOCKED';
        case CheckReturnReason.FORGERY:
            return 'FORGERY';
        case CheckReturnReason.ITEM_EXCEEDS_STATED_MAX_VALUE:
            return 'ITEM_EXCEEDS_STATED_MAX_VALUE';
        case CheckReturnReason.NON_CASH_ITEM:
            return 'NON_CASH_ITEM';
        case CheckReturnReason.NOT_AUTHORIZED:
            return 'NOT_AUTHORIZED';
        case CheckReturnReason.INSUFFICIENT_FUNDS:
            return 'INSUFFICIENT_FUNDS';
        case CheckReturnReason.OTHER_RETURN_REASON:
            return 'OTHER_RETURN_REASON';
        case CheckReturnReason.POST_DATED:
            return 'POST_DATED';
        case CheckReturnReason.ARP_OR_POSPAY_VIOLATION:
            return 'ARP_OR_POSPAY_VIOLATION';
        case CheckReturnReason.REFER_TO_MAKER:
            return 'REFER_TO_MAKER';
        case CheckReturnReason.REFER_TO_IMAGE:
            return 'REFER_TO_IMAGE';
        case CheckReturnReason.STALE_DATED:
            return 'STALE_DATED';
        case CheckReturnReason.SIGNATURE_FORGED:
            return 'SIGNATURE_FORGED';
        case CheckReturnReason.SIGNATURE_IRREGULAR:
            return 'SIGNATURE_IRREGULAR';
        case CheckReturnReason.SIGNATURE_MISSING:
            return 'SIGNATURE_MISSING';
        case CheckReturnReason.SIGNATURE_UNAUTHORIZED:
            return 'SIGNATURE_UNAUTHORIZED';
        case CheckReturnReason.UNCOLLECTED_FUNDS:
            return 'UNCOLLECTED_FUNDS';
        case CheckReturnReason.UNABLE_TO_LOCATE:
            return 'UNABLE_TO_LOCATE';
        case CheckReturnReason.UNABLE_TO_PROCESS:
            return 'UNABLE_TO_PROCESS';
        case CheckReturnReason.WARRANTY_BREACH:
            return 'WARRANTY_BREACH';
        case CheckReturnReason.REMOTE_CAPTURE_INDEMNITY:
            return 'REMOTE_CAPTURE_INDEMNITY';
        case CheckReturnReason.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.checkReturnReasonToJSON = checkReturnReasonToJSON;
//# sourceMappingURL=check-return-reason.js.map